<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Pre-Order</h3>
      </div>
      <div class="content-header-right col-md-8 col-12">
        <div class="breadcrumbs-top">
          <div class="breadcrumb-wrapper mr-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/calendar">{{this.$route.params.date}}</router-link></li>
              <li class="breadcrumb-item"><router-link v-bind:to="'/preorder/' + this.$route.params.date">Pre-Order</router-link></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body mt-0 pt-0 periods">
                <div class="text-center">
                  <br /><i class="la la-calendar calendar-icon"></i><br />
                  {{dayName}}<br />
                  {{date}}

                  <br /><br />

                  <div v-for="period in periods" v-bind:key="period.id">

                    <button type="button" class="btn btn-secondary btn-block mb-1 period-divider">{{period.title}}</button>

                    <table v-bind:class="'table-striped meal-table meal-table-' + period.id">
                      <tbody v-bind:class="'order-' + order.id" v-for="order in orders" v-bind:key="order.id" v-if="showOrderRow(order, period)">
                        <tr v-for="item in order.items" v-bind:key="item.id" v-bind:class="'item item-' + item.id">
                          <td class="text-left">{{item.label}}</td>
                          <td class="text-center">R{{item.price}}</td>
                          <td>
                            <button type="button" class="btn btn-icon btn-danger" v-on:click="removeOrder(item.id, period.id)"><i class="ft-x-circle"></i></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <button type="button" class="btn mb-1 btn-outline-primary btn-block" v-on:click="mealCategories(period.id)">Add Meal</button>
                    <!--
                    <button type="button" class="btn mb-1 btn-outline-secondary btn-block" v-on:click="deliverNow(period.id)" v-if="showDeliverNowButton()">Deliver Now</button>
                    -->
                    <hr class="mb-2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'preorder',
  data: function () {
    return {
      periods: [],
      orders: [],
      dayName: this.getDayName(),
      date: this.getDate()
    }
  },
  mounted: function () {
    var that = this
    var user = JSON.parse(window.localStorage.getItem('user'))
    var parentId = user.parent.id
    var merchantId = window.localStorage.getItem('merchantId')

    $.ajax({
      beforeSend: function (xhr) {
        $.showLoading()
        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      complete: function () {
        $.hideLoading()
      },
      url: this.$config.apiUrl + 'canteenapp_parents/calendar?parent_id=' + parentId + '&merchant_id=' + merchantId,
      type: 'get',
      success: function (data) {
        var periods = []

        if (data.success === true) {
          for (var key in data.data.periods) {
            periods.push({
              id: key,
              title: data.data.periods[key]
            })
          }
        }

        that.periods = periods

        // Now we get the orders from the calendar object
        var orders = []
        data.data.calendar.forEach(function (day) {
          if (day.orders) {
            for (var key in day.orders) {
              orders.push(day.orders[key][0])
            }
          }
        })

        that.orders = orders
      }
    })
  },
  methods: {
    getDayName: function () {
      return moment(this.$route.params.date).format('dddd')
    },
    getDate: function () {
      return moment(this.$route.params.date).format('LL')
    },
    mealCategories: function (periodId) {
      this.$router.push('/preorder/' + this.$route.params.date + '/' + periodId)
    },
    showOrderRow: function (order, period) {
      if (this.$route.params.date === order.date && order.period_id === period.id) {
        return true
      }

      return false
    },
    showDeliverNowButton: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      if (user.parent.can_deliver === 'Y') {
        return true
      }

      return false
    },
    deliverNow: function (periodId) {
      var orderId = $('.meal-table-' + periodId).find('tbody').eq(0).attr('class').replace('order-', '')

      $.ajax({
        beforeSend: function (xhr) {
          $.showLoading()
          if (window.localStorage.getItem('token')) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          }
        },
        complete: function () {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'canteenapp_orders/deliver_order_now?order_id=' + orderId,
        type: 'post',
        success: function (data) {
          swal({
            title: 'Success',
            text: 'Order is being delivered now',
            icon: 'success',
            button: 'Ok'
          })

          $('.meal-table-' + periodId).find('.item').remove()
        }
      })
    },
    removeOrder: function (mealId, periodId) {
      $.ajax({
        beforeSend: function (xhr) {
          $.showLoading()
          if (window.localStorage.getItem('token')) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          }
        },
        complete: function () {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'canteenapp_orders/remove?item_id=' + mealId,
        type: 'delete',
        success: function (data) {
          $('.meal-table-' + periodId + ' .item-' + mealId).remove()

          var user = JSON.parse(window.localStorage.getItem('user'))
          user.wallet_balance = data.data.wallet_balance
          window.localStorage.setItem('user', JSON.stringify(user))
        }
      })
    }
  }
}
</script>

<style scoped>
table.meal-table {
  width:100%;
  margin-bottom:10px;
}
.calendar-icon {

  font-size:5em;
}
.periods .period-divider {
  cursor:none;
}
.periods .period-divider:active, .periods .period-divider:hover, .periods .period-divider:focus {
  background:#6b6f80;
  color:#FFF;
}
.products td {
  padding:5px;
  vertical-align:middle;
}
</style>
